var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"custom-dnd"},[_c('div',{attrs:{"id":"drake-container"}},[_c('div',{key:1,staticClass:"item"},[_vm._v("Item 1")]),_c('div',{key:2,staticClass:"item"},[_vm._v("Item 2")]),_c('div',{key:3,staticClass:"item"},[_vm._v("Item 3")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }